import React from 'react';
import _ from 'underscore';

import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { MobileSecuritySettingsService } from '~src/settings/mobile-settings/MobileSecuritySettingsShared';
import { IMobileSecuritySettings } from '~src/settings/mobile-settings/serverApi/types/IMobileSecuritySettings';
import { MobileSiteSettingsCoordinator } from '~src/settings/mobile-settings/site-settings/MobileSiteSettingsCoordinator';
import { subspaceStyle } from '~src/settings/styles/CommonStyles';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { Sites } from '~src/siteManagement/services/resources/Sites';


interface MobileSiteSettingsSubspaceOwnProps {
  readonly server: SessionManagementService;
}

export interface MobileSiteSettingsSubspaceState {
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly siteSettingsForSiteAdmin: ISiteSettingsForSiteAdmin;
  readonly mobileSecuritySettings: IMobileSecuritySettings;
}

export class MobileSiteSettingsSubspaceComponent extends React.PureComponent<MobileSiteSettingsSubspaceOwnProps, MobileSiteSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: MobileSiteSettingsSubspaceState = {
    hasDataToRender: false,
    hasError: false,
    siteSettingsForSiteAdmin: undefined,
    mobileSecuritySettings: undefined,
  };

  public constructor(props: MobileSiteSettingsSubspaceOwnProps) {
    super(props);
    this.state = this.initialState;
  }

  public componentDidMount() {
    this.getData();
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate() {
    if (!_.isUndefined(this.state.siteSettingsForSiteAdmin)
      || (!_.isUndefined(this.state.mobileSecuritySettings) && (FeatureFlags.mobileSecuritySettingsEnabled))
    ) {
      this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      return <RouterError errorType={'server-default'} urls={undefined}/>;
    }

    return (
      <div className={subspaceStyle}>
        <MobileSiteSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof MobileSiteSettingsSubspaceState>(newState: Pick<MobileSiteSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }

  private getData = async () => {
    try {
      await this.props.server.getSessionInfoPromise();
      const siteSettings = await Sites.instance.getCurrentSiteSettingsForSiteAdmin();
      const siteId = this.props.server.sessionSiteId();
      const mobileSecuritySiteSettings = await MobileSecuritySettingsService.getMobileSecuritySettingsForSite(siteId);
      this.updateState({
        siteSettingsForSiteAdmin: siteSettings,
        mobileSecuritySettings: mobileSecuritySiteSettings
      });
    } catch (e) {
      this.updateState({hasError: true});
    }
  };
}
